export default __webpack_public_path__ + "static/media/604.d4892b2c.png";